import { render, staticRenderFns } from "./EditBSDevice.vue?vue&type=template&id=3aea5508&"
import script from "./EditBSDevice.vue?vue&type=script&lang=js&"
export * from "./EditBSDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports